export default __webpack_public_path__ + "static/media/b3.08aa8563.jpg";